import React, { useEffect, useState, useContext } from 'react';

import { fetchData } from '../../../helpers/methods';
import { CustomerContext } from '../../../contexts/customer-context';

import FormField from '../../../component-library/form-field';
import Button from '../../../component-library/button';
import SpinnerContainer from '../../../component-library/spinner-container';
import Tile from '../../../component-library/tile';
import Icon from '../../../component-library/icon';

const MyDetails = () => {
	const {
		emailConfig: {
			pattern: emailPattern = [],
		} = {},
	} = useContext(CustomerContext);
	const [loadingDetails, setLoadingDetails] = useState(true);
	const [loadingEmail, setLoadingEmail] = useState(true);
	const [errorDetails, setErrorDetails] = useState(false);
	const [errorEmail, setErrorEmail] = useState(false);
	const [displayNameError, setDisplayNameError] = useState('');
	const [emailValidationError, setEmailValidationError] = useState('');
	const [successMessage, setSuccessMessage] = useState('');
	const [emailSuccessMessage, setEmailSuccessMessage] = useState('');
	const [disableUpdateButton, setDisableUpdateButton] = useState(false);
	const [disableEmailButton, setDisableEmailButton] = useState(false);
	const [collabLabel, setCollabLabel] = useState('');
	const [collabEmail, setCollabEmail] = useState('');

	const getUserData = () => {
		setLoadingDetails(true);
		setLoadingEmail(true);
		fetchData({
			uri: '/api/web/my/store',
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newCollabLabel = body.collabLabel;
					const newCollabEmail = body.collabEmail || '';
					const regexString = emailPattern[0];
					const regex = new RegExp(regexString);
					const passRegex = regex.test(newCollabEmail);
					if (newCollabEmail !== '' && !passRegex) {
						setEmailValidationError('Your email address no longer matches the conditions set by the Catalog administrator.');
					}
					setCollabLabel(newCollabLabel);
					setCollabEmail(newCollabEmail);
					setLoadingDetails(false);
					setLoadingEmail(false);
				} else {
					setLoadingDetails(false);
					setLoadingEmail(false);
					setErrorDetails(true);
					setErrorEmail(true);
				}
			})
			.catch(() => {
				setLoadingDetails(false);
				setLoadingEmail(false);
				setErrorDetails(true);
				setErrorEmail(true);
			});
	};

	const handleSubmit = () => {
		setDisableUpdateButton(true);
		fetchData({
			uri: '/api/web/my/store/collabLabel',
			method: 'PUT',
			options: {
				body: collabLabel,
			},
		})
			.then(({ ok }) => {
				if (ok) {
					setDisableUpdateButton(false);
					setSuccessMessage('Your details have been successfully updated');
				} else {
					setDisableUpdateButton(false);
					setDisplayNameError('Your display name could not be updated at this time, please try again');
				}
			})
			.catch(() => {
				setDisableUpdateButton(false);
				setDisplayNameError('Your display name could not be updated at this time, please try again');
			});
	};

	const handleValidation = () => {
		setDisplayNameError('');
		setSuccessMessage('');
		if (collabLabel !== '') {
			handleSubmit();
		} else {
			setDisplayNameError('You must enter a display name');
		}
	};

	const handleSubmitEmail = () => {
		setDisableEmailButton(true);
		const emailData = {
			email: collabEmail || null,
		};
		fetchData({
			uri: '/api/web/my/store/collabEmail',
			method: 'PUT',
			options: {
				body: JSON.stringify(emailData),
			},
		})
			.then(({ ok }) => {
				if (ok) {
					setDisableEmailButton(false);
					setEmailSuccessMessage('Your details have been successfully updated');
				} else {
					setDisableEmailButton(false);
					setEmailValidationError('Your email could not be updated at this time, please try again');
				}
			})
			.catch(() => {
				setDisableEmailButton(false);
				setEmailValidationError('Your email could not be updated at this time, please try again');
			});
	};

	const handleEmailValidation = () => {
		setEmailValidationError('');
		setEmailSuccessMessage('');
		const regexString = emailPattern[0];
		const regex = new RegExp(regexString);
		const passRegex = regex.test(collabEmail);
		if (collabEmail === '' || passRegex) {
			handleSubmitEmail();
		} else {
			setEmailValidationError('The entered email address does not match the conditions set by the Catalog administrator.');
		}
	};

	useEffect(() => {
		getUserData();
	}, []);

	return (
		<>
			<h3>Details</h3>
			<Tile>
				{loadingDetails && (
					<SpinnerContainer />
				)}
				{!loadingDetails && !errorDetails && (
					<>
						<div className="profile__form-help-grid">
							<div>
								<FormField
									type="text"
									label="Display Name"
									placeholder="Enter your display name here..."
									action={e => { setCollabLabel(e.target.value); }}
									id="display_name"
									name="display_name"
									value={collabLabel}
									error={displayNameError}
									fullWidth
								/>
							</div>
							<div>
								<Icon
									icon="circle-question"
									title="Your display name is used when adding comments or contacting a provider"
									classes="profile__help-icon"
								/>
							</div>
						</div>
						<div className="margin-top-16 flex-row justify-space-between align-items-center">
							<div className="font-color-theme-success">
								{successMessage && (successMessage)}
							</div>
							<Button
								type="primary"
								label="Update Details"
								isDisabled={disableUpdateButton}
								onClick={() => handleValidation()}
							/>
						</div>
					</>
				)}
				{errorDetails && (
					<p className="grey-text">Sorry, we could not load your details at this time, please try again.</p>
				)}
			</Tile>
			<h3 className="margin-top-32">Email Notifications</h3>
			<Tile>
				{loadingEmail && (
					<SpinnerContainer />
				)}
				{!loadingEmail && !errorEmail && (
					<>
						<div className="profile__form-help-grid">
							<div>
								<FormField
									type="email"
									label="By entering your email address, you opt-in to receive email notifications"
									placeholder="Enter your email"
									action={e => { setCollabEmail(e.target.value); }}
									id="display_name"
									name="display_name"
									value={collabEmail}
									error={emailValidationError}
									fullWidth
								/>
							</div>
							<div>
								<Icon
									icon="circle-question"
									title="Your email address is used to send email notifications, if you wish to opt-out, please delete your email address"
									classes="profile__help-icon"
								/>
							</div>
						</div>
						<div className="margin-top-16 flex-row justify-space-between align-items-center">
							<div className="font-color-theme-success">
								{emailSuccessMessage && (emailSuccessMessage)}
							</div>
							<Button
								type="primary"
								label="Update Email"
								isDisabled={disableEmailButton}
								onClick={() => handleEmailValidation()}
							/>
						</div>
					</>
				)}
				{errorEmail && (
					<p className="grey-text">Sorry, we could not load your email at this time, please try again.</p>
				)}
			</Tile>
		</>
	);
};

export default MyDetails;
